import { Link } from 'react-router-dom';
import './Hero.css';

export default function Hero() {
  return (
    <div className="page">

      {/* ── Hero ── */}
      <section className="hero">
        <div className="hero__overlay" />

        <div className="hero__content">

          {/* Trustpilot */}
          <div className="hero__trustpilot">
            <span className="tp__logo">★</span>
            <span className="tp__name">Trustpilot</span>
            <span className="tp__rating">Excellent</span>
            <div className="tp__stars">
              {[1,2,3,4].map(i => <span key={i} className="tp__star tp__star--full">★</span>)}
              <span className="tp__star tp__star--half">★</span>
            </div>
            <span className="tp__count">233,370 reviews</span>
          </div>

          {/* Headline */}
          <h1 className="hero__title">
            Delayed or canceled flight?<br />
            <span className="hero__title-bold">Get up to $650!</span>
          </h1>

          {/* Subtext */}
          <p className="hero__sub">
            You've got rights when your flight's disrupted. We enforce them and
            handle everything so you get paid.
          </p>

          {/* CTA */}
          <Link to="/check-compensation" className="hero__cta">
            Check My Compensation 
          </Link>

        </div>
      </section>

    </div>
  );
}